var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.reportType === 'term')?_c('report',{attrs:{"data":_vm.data,"type":_vm.campusType,"schoolYearType":_vm.schoolYearType}}):(_vm.reportType === 'yearly')?_c('yearly-report',{attrs:{"data":_vm.data,"type":_vm.campusType}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }